import React from 'react';
import FadeIn from '../animations/FadeIn';

const md = require('markdown-it')({ html: true });

function ColumnBlocks({
  title,
  description,
  blocks,
  blockColor = 'var(--white)',
  bgColor,
  textColor,
  padding,
}) {
  return blocks?.length > 0 ? (
    <div
      className="w-full"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="w-full hidden lg:block" style={{ height: padding }} />
      <div
        className="w-full block lg:hidden"
        style={{ height: padding, backgroundColor: blockColor }}
      />
      <div className="max-w-[1580px] mx-auto lg:px-8">
        {title && (
          <h2 className="text-[2.25rem] leading-[1.2] !mb-6 max-w-3xl mx-auto text-center">
            {title}
          </h2>
        )}
        {description && (
          <p className="text-[0.9rem] leading-[1.6] !mb-0 max-w-3xl mx-auto lg:px-10 text-center">
            {description}
          </p>
        )}
        <div className="lg:grid lg:grid-cols-3 lg:items-stretch lg:gap-8 lg:p-8 lg:py-12 text-center font-sonoma font-light">
          {blocks.map(({ text }, i) =>
            text ? (
              <FadeIn key={i}>
                <div
                  className={`lg:rounded-lg pb-0 !lg:pb-[50px] px-[50px] py-[50px] lg:py-[125px] lg:h-full flex flex-col items-center justify-center bg-white ${
                    i === 0 ? 'pt-0 lg:pt-[125px]' : ''
                  }`}
                  style={{ backgroundColor: blockColor }}
                  dangerouslySetInnerHTML={{ __html: md.render(text) }}
                />
              </FadeIn>
            ) : null,
          )}
        </div>
      </div>
      <div
        className="w-full block lg:hidden"
        style={{ height: padding, backgroundColor: blockColor }}
      />
      <div className="w-full hidden lg:block" style={{ height: padding }} />
    </div>
  ) : null;
}

export default ColumnBlocks;
